import React from 'react';

const BigBtn = ({ children, onClick, disabled = false, primary = false, ghost = false, color, fullWidth = true }) => {
  const bg = disabled
    ? '#00000015'
    : color
      ? `var(--c-${color})`
      : ghost
        ? 'var(--c-cream)'
        : primary
          ? 'var(--c-pink)'
          : 'var(--c-yellow)';

  const fg = disabled
    ? 'var(--c-ink)'
    : ghost
      ? 'var(--c-ink)'
      : primary
        ? 'var(--c-cream)'
        : 'var(--c-ink)';

  const press = (e, down) => {
    if (disabled) return;
    e.currentTarget.style.transform = down ? 'translate(2px, 2px)' : 'translate(0, 0)';
    e.currentTarget.style.boxShadow = down ? 'var(--shadow-hard-sm)' : 'var(--shadow-hard)';
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      onMouseDown={(e) => press(e, true)}
      onMouseUp={(e) => press(e, false)}
      onMouseLeave={(e) => press(e, false)}
      onTouchStart={(e) => press(e, true)}
      onTouchEnd={(e) => press(e, false)}
      style={{
        flex: fullWidth ? 1 : '0 0 auto',
        fontFamily: 'var(--font-display)',
        fontSize: 15,
        letterSpacing: 0.8,
        padding: '14px 14px',
        borderRadius: 'var(--radius-btn)',
        border: 'var(--border-ink)',
        background: bg,
        color: fg,
        cursor: disabled ? 'default' : 'pointer',
        boxShadow: disabled ? 'none' : 'var(--shadow-hard)',
        opacity: disabled ? 0.7 : 1,
        transition: 'transform 80ms, box-shadow 80ms',
        textAlign: 'center',
      }}
    >
      {children}
    </button>
  );
};

export default BigBtn;
